module.exports = __webpack_public_path__ + "./docs/img/vox-flutter.c9dd1b9affc17587c2b802f716463bda.svg";